import {
  type CreateAccountOutput,
  type Guard,
  type SignInOutput,
} from '../join-or-sign-in-machine.types';
import { logger } from './join-or-sign-in-machine.logger';

// ─── Guards ──────────────────────────────────────────────────────────────────

const checkIfSignedIn: Guard<SignInOutput> = (_args, params) => {
  return params.hasSignedIn;
};

const checkIfSignedUp: Guard<CreateAccountOutput> = (_args, params) => {
  return params.hasCreatedAccount;
};

// ─── External Guards ─────────────────────────────────────────────────────────

const checkIfNeedToRefreshTokens: Guard = () => {
  logger.debug('`checkIfNeedToRefreshTokens` guard is not provided.');

  return true;
};

// ─────────────────────────────────────────────────────────────────────────────

export const Guards = {
  checkIfSignedIn,
  checkIfSignedUp,
  checkIfNeedToRefreshTokens,
};
